import React, { useState, useEffect, useCallback } from 'react';
import PlatformAnalyticsCards from './child/PlatformAnalyticsCards';
import UsersOverviewOne from './child/UsersOverviewOne';
import LatestRegisteredOne from './child/LatestRegisteredOne';
import PlatformFavoritesTable from './child/PlatformFavoritesTable';
import SavesActivityChart from './child/SavesActivityChart';
import { useAuth } from '../context/AuthContext';
import config from '../config';

/**
 * Platform Analytics Layer (PDF Pages 6 & 7)
 * Strictly consumer mobile app engagement and activity.
 */
const DashBoardLayerOne = () => {
    const { auth } = useAuth();
    const [stats, setStats] = useState({
        total_mobile_users: 0,
        total_saves: 0,
        venue_saves: 0,
        content_saves: 0,
        total_reviews: 0,
        unique_customers: 0,
        saves_activity: []
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const fetchPlatformStats = useCallback(async () => {
        try {
            setLoading(true);
            setError(false);
            const response = await auth.fetch(`${config.API_BASE_URL}/api/stats/platform-analytics`);
            if (response.ok) {
                const data = await response.json();
                setStats(data);
            } else {
                setError(true);
            }
        } catch (err) {
            console.error('Failed to fetch platform stats:', err);
            setError(true);
        } finally {
            setLoading(false);
        }
    }, [auth]);

    useEffect(() => {
        fetchPlatformStats();
    }, [fetchPlatformStats]);

    return (
        <div className="d-flex flex-column gap-4">
            {/* 6 Static KPI Cards (Page 6) */}
            <PlatformAnalyticsCards 
                stats={stats} 
                loading={loading} 
                error={error} 
                onRetry={fetchPlatformStats} 
            />

            {/* User Analytics: Growth Chart & Latest Registered Users */}
            <section className="row gy-4">
                <UsersOverviewOne className="col-xxl-4 col-xl-5 col-12" />
                <LatestRegisteredOne className="col-xxl-8 col-xl-7 col-12" />
            </section>

            <section className="row gy-4">
                <div className="col-12">
                    <SavesActivityChart data={stats.saves_activity || []} loading={loading} />
                </div>
            </section>

            {/* Platform Customer Favorites Aggregated Table (Page 6) */}
            <section className="row gy-4">
                <div className="col-12">
                    <PlatformFavoritesTable />
                </div>
            </section>
        </div>
    );
};

export default DashBoardLayerOne;
